var map = {
	"./avatar.jpg": "IIfh",
	"./delete-gray.png": "yJ2U",
	"./delete-red.png": "djtH",
	"./emojis": "EzSH",
	"./emojis.json": "EzSH",
	"./file.png": "nd50",
	"./file/file_Excel.png": "FX06",
	"./file/file_MP3.png": "30X6",
	"./file/file_avi.png": "4KJp",
	"./file/file_pdf.png": "0M0F",
	"./file/file_ppt.png": "lFao",
	"./file/file_txt.png": "D1w/",
	"./file/file_unknown.png": "8Xdz",
	"./file/file_world.png": "kkR5",
	"./file/file_zip.png": "vBCw",
	"./kayi-logo-white.png": "jacJ",
	"./kayi-logo.png": "njxU",
	"./logo.png": "/KAl",
	"./man.png": "C9B2",
	"./message-prompt.mp3": "2/+M",
	"./message.png": "CjT1",
	"./record.png": "r1/j",
	"./unknown.png": "JoM1",
	"./voice-black.png": "QmUS",
	"./voice-black2.png": "01T9",
	"./voice-white.png": "T3MC",
	"./woman.png": "irsg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "iNTJ";


//////////////////
// WEBPACK FOOTER
// ./packages/assets ^\.\/.*$
// module id = iNTJ
// module chunks = 1